import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from '../../i18n/hooks/useTranslation';

interface IntegrationComingSoonProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export const IntegrationComingSoon: React.FC<IntegrationComingSoonProps> = ({
  title,
  description,
  icon
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 p-6 h-full flex flex-col relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }}></div>
      </div>

      <div className="mb-4 relative z-10">
        <div className="flex items-start mb-3">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center mr-3 flex-shrink-0 bg-gray-100 dark:bg-gray-700">
            {icon}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-1">
              {title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              {description}
            </p>
          </div>
        </div>
      </div>

      {/* Coming Soon Badge */}
      <div className="mt-auto pt-4 relative z-10">
        <div className="relative group">
          {/* Glow effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary-400 to-accent-400 blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
          
          {/* Badge */}
          <div className="relative bg-gradient-to-r from-primary-500 to-accent-500 text-white rounded-lg px-4 py-3 shadow-lg flex items-center justify-center space-x-2 cursor-default">
            <Sparkles className="w-4 h-4 animate-pulse" />
            <span className="text-sm font-bold tracking-wide uppercase">Coming Soon</span>
          </div>
        </div>
        
        <p className="mt-3 text-xs text-center text-gray-500 dark:text-gray-400">
          {t('admin.comingSoonIntegration') || 'This integration will be available in a future release'}
        </p>
      </div>
    </div>
  );
};
